const initialState = {
  projects: [],
  archivedProjects: [],
  archivedCount: 0,
  activeProject: null,
  projectActivities: [],
};

const Projects = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PROJECTS':
      return {
        ...state,
        projects: Array.isArray(action.projects) ? action.projects : state.projects,
        archivedCount: action.archivedCount != null ? action.archivedCount : state.archivedCount,
      };
    case 'REORDER_PROJECTS_KANBAN': {
      const pos = {};
      (action.ids || []).forEach((id, i) => { pos[id] = i; });
      return {
        ...state,
        projects: state.projects.map((p) => (pos[p.id] != null ? { ...p, kanban_position: pos[p.id] } : p)),
      };
    }
    // Déplacement inter-colonnes OPTIMISTE : pose l'étape ET le rang de la carte déplacée
    // synchroniquement (avant l'aller-retour serveur), sinon react-beautiful-dnd fait
    // revenir la carte à la source le temps du PATCH, puis la réponse la renvoie à
    // destination = scintillement. Réutilise l'ordre absolu `ids` de la colonne cible.
    case 'MOVE_PROJECT_STAGE_KANBAN': {
      const pos = {};
      (action.ids || []).forEach((id, i) => { pos[id] = i; });
      return {
        ...state,
        projects: state.projects.map((p) => {
          if (p.id === action.projectId) {
            return {
              ...p,
              stage: action.stage,
              kanban_position: pos[p.id] != null ? pos[p.id] : p.kanban_position,
            };
          }
          return pos[p.id] != null ? { ...p, kanban_position: pos[p.id] } : p;
        }),
      };
    }
    case 'SET_ARCHIVED_PROJECTS':
      return {
        ...state,
        archivedProjects: Array.isArray(action.projects) ? action.projects : state.archivedProjects,
      };
    case 'SET_ACTIVE_PROJECT':
      return {
        ...state,
        activeProject: action.activeProject,
      };
    case 'RESET_ACTIVE_PROJECT':
      return {
        ...state,
        activeProject: null,
      };
    case 'SET_PROJECT_ACTIVITIES':
      return {
        ...state,
        projectActivities: action.payload,
      };
    case 'ADD_PROJECT_ACTIVITY':
      return {
        ...state,
        projectActivities: [action.payload, ...state.projectActivities],
      };
    default:
      return state;
  }
};

export default Projects;
